import * as React from 'react';

import {UserIcon} from 'shells/icon/svg/user-icon';
import {RadioGroup} from 'shells/radio/radio-group';

import type {MeetingType} from 'nutshell-graphql-types';

import {SOLO_HOST} from './create-meeting-modal';
import {HostTypeSelectRadio} from './host-type-select-radio';
import {ManagedMeetingRadioSelect} from './managed-meeting-radio-select';
import {MeetingCohostSelect} from './meeting-cohost-select';
import {MeetingRoundRobinSelect} from './meeting-round-robin-select';
import type {CohostUserOption} from './use-get-cohost-user-options';

type Props = {
    cohostUserOptions: CohostUserOption[] | null | undefined;
    selectedHostType: MeetingType;
    setSelectedHostType: (hostType: MeetingType) => void;
    selectedCohostIds: string[];
    setSelectedCohostIds: (userIds: string[]) => void;
    selectedTeamId: string | null | undefined;
    setSelectedTeamId: (teamId?: string | null | undefined) => void;
    hasFullSchedulerAccess?: boolean;
    isAdmin?: boolean;
    onSearchChange: (search: string) => void;
};

export function MeetingHostTypeSelection(props: Props) {
    return (
        <div>
            <RadioGroup
                name='meeting-host-type'
                selectedValue={props.selectedHostType}
                // @ts-expect-error
                onChange={(value: MeetingType) => {
                    props.setSelectedHostType(value);
                }}
            >
                <HostTypeSelectRadio
                    value={SOLO_HOST}
                    label='Solo'
                    sublabel='You’ll be the only host.'
                    icon={<UserIcon size={13} wrapWithDiv={false} />}
                />
                <MeetingCohostSelect
                    cohostUserOptions={props.cohostUserOptions}
                    selectedCohostIds={props.selectedCohostIds}
                    setSelectedCohostIds={props.setSelectedCohostIds}
                    setSelectedTeamId={props.setSelectedTeamId}
                    selectedHostType={props.selectedHostType}
                    setSelectedHostType={props.setSelectedHostType}
                    onSearchChange={props.onSearchChange}
                />
                {typeof props.hasFullSchedulerAccess === 'boolean' && (
                    <MeetingRoundRobinSelect
                        selectedTeamId={props.selectedTeamId}
                        setSelectedTeamId={props.setSelectedTeamId}
                        setSelectedCohostIds={props.setSelectedCohostIds}
                        selectedHostType={props.selectedHostType}
                        setSelectedHostType={props.setSelectedHostType}
                        canAccessRoundRobin={props.hasFullSchedulerAccess}
                    />
                )}
                {typeof props.isAdmin === 'boolean' &&
                    typeof props.hasFullSchedulerAccess === 'boolean' &&
                    props.isAdmin && (
                        <ManagedMeetingRadioSelect
                            canAccessManagedMeetings={props.isAdmin && props.hasFullSchedulerAccess}
                        />
                    )}
            </RadioGroup>
        </div>
    );
}
